// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signup-modal{text-align:center}.signup-modal .login-link{text-decoration:underline;display:inline;color:inherit}.heading{text-align:center;font-size:21px}.description{text-align:center;font-size:14px}.signup{width:100%;background-color:#333;width:fit-content;margin:18px auto;padding:12px 24px;font-size:12px}.signup:hover{background-color:#000}.terms{margin:18px 0;text-align:center}.terms a{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
